var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg500({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.959 239.413C374.733 239.413 362.999 236.356 352.759 230.24C342.661 223.982 334.697 215.022 328.866 203.36C323.177 191.556 320.332 177.547 320.332 161.333C320.332 145.12 323.177 131.182 328.866 119.52C334.697 107.716 342.661 98.7555 352.759 92.64C362.999 86.3822 374.733 83.2533 387.959 83.2533C401.186 83.2533 412.848 86.3822 422.946 92.64C433.186 98.7555 441.15 107.716 446.839 119.52C452.67 131.182 455.586 145.12 455.586 161.333C455.586 177.547 452.67 191.556 446.839 203.36C441.15 215.022 433.186 223.982 422.946 230.24C412.848 236.356 401.186 239.413 387.959 239.413ZM387.959 199.093C399.337 199.093 405.026 186.507 405.026 161.333C405.026 136.16 399.337 123.573 387.959 123.573C376.581 123.573 370.892 136.16 370.892 161.333C370.892 186.507 376.581 199.093 387.959 199.093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1583 139.36C115.065 139.36 130.425 143.769 140.238 152.587C150.194 161.262 155.172 172.711 155.172 186.933C155.172 196.32 152.683 204.996 147.705 212.96C142.869 220.782 135.332 227.182 125.092 232.16C114.852 236.996 102.123 239.413 86.905 239.413C76.3806 239.413 65.8561 238.276 55.3317 236C44.9494 233.724 35.8472 230.382 28.025 225.973L45.0917 188.853C51.3494 192.409 57.8917 195.111 64.7183 196.96C71.6872 198.809 78.4428 199.733 84.985 199.733C90.8161 199.733 95.5094 198.738 99.065 196.747C102.763 194.613 104.612 191.698 104.612 188C104.612 184.444 102.976 181.813 99.705 180.107C96.4339 178.258 90.5317 177.333 81.9983 177.333H38.6917L46.1583 86.6666H145.358V124.64H87.545L86.4783 139.36H94.1583Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 83,
    stroke: "#FF7B2E",
    strokeOpacity: 0.6,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 190.961H235.334V204.66H245.667V190.961Z",
    fill: "#FF7B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 180.687H235.333L225 114.45H256L245.667 180.687Z",
    fill: "#FF7B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg500);
export default __webpack_public_path__ + "static/media/img_500.5ea50a3991c6c251aee72a3eaac337e7.svg";
export { ForwardRef as ReactComponent };